import { serviceOperationApi } from "./api";

export async function updateAdminFinRequest({ row, accessToken }) {
  const res = await serviceOperationApi.post(
    "/UpdateAdminFin",
    { document: row },
    { headers: { Authorization: `Bearer ${accessToken}` } },
  );
  return res.data;
}
